<template>
  <div class="location-picker">
    <div v-if="loadingState" class="
  z-40 overflow-auto scrolling-touch left-0 top-0 bottom-0 right-0 w-full h-full overlay-t-modal-custom fixed bg-opacity-50 bg-black
  ">
      <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
        <svg class="h-24 w-24 animate-spin text-blue-600 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"></circle>
          <path d="M12 2 A 10 10 0 0 1 22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>
        </svg>
      </div>
    </div>
    <t-modal-open-map ref="openModalMap" class="w-1/2" @closed="handleCloseMap">
      <div class="w-full mx-auto p-0 bg-white rounded-lg">
        <div class="flex justify-between items-center">
          <div>
            <h2 class="text-xl font-bold mb-0">Add New Location</h2>
          </div>
          <div @click="closeMoap" class="cursor-pointer">
            <i class="fa fa-times text-gray-500 text-lg font-light" aria-hidden="true"></i>
          </div>
        </div>
        <div v-if="permission_location" class="bg-orange-50 p-3 rounded-lg my-4">

          <h2 class="text-base font-semibold mb-0 text-yellow-600">Location Access Not Active</h2>
          <p class="text-sm text-yellow-600 m-0 ">To use the Read on Site feature, enable location permissions in your
            browser.</p>
        </div>
        <div class="flex justify-between items-start w-full my-4">

          <div class="flex w-auto items-center justify-start">
            <span class="text-blue-600">
              <i class="fa fa-check-circle" aria-hidden="true"></i>
              Find Access Location</span>
            <div class="h-0.5 w-20 bg-blue-500 ml-3"></div>
          </div>
          <div class="flex w-auto items-center justify-start">
            <span :class="{
              'text-blue-600': showMap,
              'text-gray-500 opacity-50': !showMap
            }">
              <i class="fa fa-check-circle" aria-hidden="true"></i>
              Set Coordinate Point</span>
            <div :class="{
              'bg-blue-500': confirmLocation,
              'bg-gray-500 opacity-50': !confirmLocation
            }" class="h-0.5 w-20 ml-3"></div>
          </div>
          <div class="flex w-auto items-center justify-start">
            <span :class="{
              'text-blue-600': confirmLocation,
              'text-gray-500 opacity-50': !confirmLocation
            }"> <i class="fa fa-check-circle" aria-hidden="true"></i> Define Access Radius</span>
          </div>

        </div>
        <div class="form-group" style="position: relative; z-index: 9999;">
          <label v-if="!showMap" class="text-base font-medium">Access Point or Location</label>
          <div class="relative" v-if="!showMap">
            <i class="fa-solid fa-magnifying-glass text-gray-400 text-base absolute top-3 left-4"></i>
            <input :class="{
              'bg-gray-50': this.permission_location,
              'bg-white': !this.permission_location
            }" :disabled="this.permission_location" type="text" v-model="searchQuery" @input="searchLocationsMap"
              placeholder="Search by location name, street, building, or latitude & longitude"
              class="custom-search-input rounded-xl pl-10 text-sm  py-2.5 border w-full" />
            <small v-if="isLocationSearch" style="color: gray;">Mencari lokasi...</small>

            <div v-if="!permission_location" class="form-group mt-4 w-full">
              <div class="bg-white border rounded-xl w-full overflow-hidden">
                <div @click="getCurrentLocation" :class="searchResults && searchResults.length > 0 ? 'py-3' : 'py-2.5'"
                  class="flex items-center px-3 text-gray-700 cursor-pointer hover:bg-gray-50">
                  <i class="fa-solid fa-location-crosshairs text-lg mr-3 text-gray-400"></i>
                  <span class="text-sm text-gray-700">Use current location</span>
                </div>

              <ul v-if="searchResults && searchResults.length > 0" class="bg-white border-t max-h-72 overflow-y-auto">
  
  <li 
    v-for="(result, index) in searchResults" 
    :key="`${result.place_id}-${index}`" 
    @click="onLocationSelected(result)"
    class="flex items-start px-3 py-2.5 cursor-pointer hover:bg-gray-50 transition-colors"
  >
    
    <div class="mt-0.5 shrink-0">
      <img class="w-4 h-4 mr-3 opacity-80" :src="require('@/assets/img/pinlocation.svg')" alt="pin" />
    </div>

    <div class="flex flex-col">
      <div class="text-sm font-medium text-gray-900 tracking-wide">{{ result.name }}</div>
      <div class="text-xs font-normal text-gray-500 mt-1 leading-snug pr-2">
        {{ result.display_name }}
      </div>
    </div>
    
  </li>
</ul>
                
               <div class="border-t text-center" v-if="stateEmpty && searchQuery && searchResults && searchResults.length === 0">
  <div class="flex justify-center my-3 flex-col">
    <p class="m-0 text-sm font-bold leading-5">Location "{{ searchQuery }}" Not Found</p>
    <p class="m-0 text-xs text-gray-500 leading-5">
      Try using your current location or type another address in the search box.
    </p>
  </div>
</div>

              </div>

            </div>
          </div>
          <div v-if="showMap && !confirmLocation" class="flex-col border p-3 rounded-lg">
            <div class="flex justify-start items-center space-x-4">
              <div> <i class="fa-solid fa-location-dot mr-1 text-xl"></i> </div>
              <div class="flex-col">
                <div>
                  <p class="text-xs text-gray-500 m-0">Address Input</p>
                </div>
                <div class="font-medium text-sm leading-5">{{ this.name }}</div>
                <div class="text-xs font-normal text-gray-500 leading-4">
                  {{ this.searchQuery }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <label v-if="showMap && !confirmLocation" class="text-base font-medium">Pin Point</label>
        <label v-if="showMap && confirmLocation" class="text-base font-medium">Set the range/radius from the location
          point.</label>

        <div v-if="showMap" class="map-container relative rounded-xl overflow-hidden mt-0"
          style="height: 450px; width: 100%; margin-top: 20px; border: 1px solid #ddd;">
          <l-map :zoom="zoom" :center="center" ref="myMap" style="height: 100%; width: 100%; z-index: 1;">
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
            <l-circle :lat-lng="markerPosition" :radius="Number(radius) || 0" color="#3388ff" fill-color="#3388ff"
              :fill-opacity="0.2"></l-circle>
            <l-marker :lat-lng="markerPosition" :draggable="lockLocation ? false : true"
              @dragend="onMarkerDragEnd"></l-marker>
          </l-map>
          <div v-if="showMap && confirmLocation"
            class="absolute bottom-0 left-0 z-50 w-full bg-white h-20 shadow-lg flex justify-center items-center">
            <div class="flex items-center space-x-4 px-4 w-full ">

              <div class="shrink-0">
                <img class="w-6 h-6" :src="require('@/assets/img/pinlocation.svg')" alt="pin" />
              </div>

              <div class="flex flex-col text-left">
                <div class="font-medium text-sm leading-5 text-gray-900">{{ name }}</div>
                <div class="text-xs font-normal text-gray-500 leading-4 line-clamp-2 mt-0.5">
                  {{ searchQuery }}
                </div>
              </div>

            </div>

          </div>
        </div>
        <div v-if="confirmLocation">
          <div class="mt-3 mb-1">
              <label class="text-base text-gray-800 font-medium mb-0 leading-7">Set Access Radius</label>
            
          </div>
          <div class="flex " style="display: flex; gap: 20px; margin-top: 0px;">
            <div class="flex flex-col w-5/12" style="flex: 1;">
              <label class="text-xs">Reading Radius (50 - 2,000 Meters)</label>
              <div class="flex relative justify-start items-center text-center align-middle">
                <input type="number" v-model.number="radius" min="0" max="2000" @input="validateRadius"
                  class="border-gray-200 text-xs py-2.5 bg-gray-50 rounded-tl-xl rounded-bl-xl"
                  :class="{ 'bg-red-200 text-red-500 border-red-400': validateRadiusLocation }" />
                <div :class="{ 'bg-red-200 border-red-400': validateRadiusLocation }"
                  class="h-full text-center align-middle items-center flex px-14 rounded-tr-xl rounded-br-xl border-t border-r border-b bg-gray-100">
                  <span :class="{ ' text-red-500': validateRadiusLocation }">Meters</span>
                </div>
              </div>
              <p class="text-xs font-normal text-red-500 mt-2" v-if="validateRadiusLocation">
                {{ radiusErrorMessage }}
              </p>
            </div>

            <div class="flex flex-col w-full">
              <label class="text-xs">Location Tag</label>
              <input type="text" v-model="locationTag" placeholder="Write the location name as a marker (e.g., reading point buildin..."
                class=" border-gray-200 py-2.5 bg-gray-50 rounded-xl text-xs"
                :class="{ 'bg-red-200 placeholder-red-500 border-red-400': validateLocation }" />
              <p class="text-sm font-normal text-red-500 mt-2" v-if="validateLocation">Must be filled in</p>
            </div>

          </div>
          <div class="flex justify-start items-start space-x-3 mt-3">
            <Button @click="confirmationSubmitLocation" class="flex justify-items-start items-center" size="sm">
              Save Location
            </Button>
            <Button @click="handleBackSetLocation" class="flex border justify-items-start items-center"
              ovariant="outlined" color="alternative" size="sm">
              Back
            </Button>
          </div>
        </div>

        <div v-if="showMap && !confirmLocation" class="flex justify-start items-start space-x-3 mt-3">
          <Button @click="confirmLocationData" class="flex justify-items-start items-center" size="sm">
            Confirm Location & Continue
          </Button>
          <Button @click="handleCloseMap" class="flex border justify-items-start items-center" ovariant="outlined"
            color="alternative" size="sm">
            Back
          </Button>
        </div>

      </div>
    </t-modal-open-map>
    <t-modal ref="openModalConfirmationSubmitLocation">
      <div class="flex-col justify-center text-center">
        <label class="text-center font-semibold text-sm text-gray-800 tracking-normal">Ensure the Location is
          Correct</label>
        <p class="text-gray-500 text-xs font-normal">The system will generate a QR Code based on this location. Data
          cannot be changed once saved.</p>
      </div>
      <div class="flex justify-center items-center space-x-3">
        <Button @click="() => {
          this.$refs.openModalConfirmationSubmitLocation.hide();
          this.$refs.openModalMap.show()
        }" size="sm">
          <span class="text-xs">
            Double Check
          </span>
        </Button>
        <Button variant="outlined" @click="submitLocation" color="alternative" size="sm">
          <span class="text-xs">
            Yes, Proceed & Generate QR
          </span>
        </Button>
      </div>
    </t-modal>
    <t-modal @before-close="onBeforeCloseModalStatus" ref="modalConfirmationStatus">
      <div class="flex-col justify-center text-center p-0">
        <label class="text-center font-semibold text-base text-gray-800 tracking-normal">
          {{pendingStatusChange == 1 ? 'Active' : 'Deactivate'}} Location
        </label>
        <p v-if="pendingStatusChange == 1" class="text-gray-500 text-sm font-normal mt-0">
          Users within this location will be able to access onsite content after this location is activated.
        </p>
        <p v-else-if="pendingStatusChange == 9" class="text-gray-500 text-sm font-normal mt-0">
          Users within this location will no longer be able to access onsite content after this location is deactivated.
        </p>
      </div>
      <div class="flex justify-center items-center space-x-3 mt-4">

        <Button v-if="pendingStatusChange == 1" @click="confirmStatusChange" size="sm">
          Activate Location
        </Button>

        <Button v-else-if="pendingStatusChange == 9" color="red" class="bg-red-500 text-white" variant="default"
          @click="confirmStatusChange" size="sm">
          Deactivate Location
        </Button>

        <Button @click="cancelStatusChange" variant="outlined" color="alternative" size="sm">
          Cancel
        </Button>

      </div>
    </t-modal>
    <t-modal-file ref="openDatalocation">
      <div v-if="savedLocationData" class="flex flex-col items-center py-6">
        <div class="text-center mb-6">
          <h3 class="text-base font-semibold text-gray-800">Access Location Ready for Use</h3>
        </div>

        <div class="flex-col">
          <div class="p-3 border">
            <img :src="savedLocationData.qr_image" alt="QR Code" class="w-full" />
          </div>

        </div>

        <div class="bg-gray-50 rounded-xl w-full p-2.5 my-3 flex-col justify-center items-center text-center">
          <p class="text-base font-semibold m-0">Titik Baca {{ savedLocationData.name }}</p>
          <div class="flex justify-center items-center space-x-5">
            <p class="text-gray-500 text-sm my-0 ">Radius {{ savedLocationData.allowed_radius }} Meters </p>
            <p class="text-gray-500 text-sm my-0">{{ savedLocationData.latitude }} {{ savedLocationData.longitude }}
            </p>
          </div>
        </div>
        <p class="text-gray-500 p-2 text-center">The coordinates and radius have been saved. Users can only access the
          SmartPin collection from this area.</p>
        <!-- Detail Lokasi -->
        <div class="flex space-x-4 w-full justify-center">
          <Button ovariant="outlined" color="alternative" size="sm" @click="downloadQR"
            class=" border-t border-b border-l border-r  border-blue-500 text-sm text-blue-500 items-center">
            Download QR Code
          </Button>
          <Button @click="$router.push(`/smart-pin/location/${savedLocationData.id}`)"
            class="flex justify-items-start items-center" size="sm">
            View Detail Location
          </Button>
        </div>
      </div>
    </t-modal-file>
    <HeaderBreadcrumbs :items="[
      { label: 'Smartpin' },
    ]" title="Access Location" />
    <div class="flex justify-between items-end bg-white py-3 px-4">
      <div class="w-2/6 flex-col">
        <div class="mb-1">
          <label class="font-bold text-xl text-gray-700">List of Location</label>
        </div>
        <div class="relative">
          <i class="fa-solid fa-magnifying-glass text-gray-400 text-base absolute top-3 left-3"></i>
          <input placeholder="Search by Tag Location" class="p-2.5 pl-5 mb-1 w-full text-sm border rounded-lg"
            type="search" v-model="query_search" @input="onSearch" v-on:keyup.enter="onSearch" />
        </div>

      </div>
      <div class="flex space-x-4 justify-start items-center">
        <Button @click="handleOpenModalMap" class="flex justify-items-start items-center" size="sm">
          + Add Location
        </Button>
        <Button @click="exportCSV" :disabled="isExporting"
          class="flex border space-x-2 justify-center items-start transition-all duration-300"
          :class="isExporting ? 'bg-gray-100 cursor-not-allowed opacity-60' : 'bg-white hover:bg-gray-50'"
          variant="outlined" color="alternative" size="sm">
          <div class="text-xs flex justify-center items-center"
            :class="isExporting ? 'text-gray-400' : 'text-gray-700'">
            {{ isExporting ? `Wait (${exportCountdown}s)` : 'Export CSV' }}
          </div>
        </Button>
      </div>
    </div>
    <div>
      <Table :headers="headers" :data="listLocation" :isLoading="isloadingLocation" :withScrollX="false"
        :row-key="['name', 'allowed_radius', 'active_book_count', 'reading_progress']" :withSelectable="false"
        :withPagination="false" :withAction="true" :withActionsFirst="false" :withNumberCol="false" class="shadow-none">
        <template #name="{ row }">
          <div class="field-wrapper w-96">
            <router-link :to="`/smart-pin/location/${row.id}`"
              class="p-2.5 rounded-lg w-full text-blue-600 font-medium text-sm underline leading-6 tracking-wide">
              {{ row.name }}
            </router-link>

          </div>
        </template>
        <template #allowed_radius="{ row }">
          <div class="field-wrapper">
            <span class="rounded-lg w-full">
              {{ Number(row.allowed_radius).toLocaleString('id-ID') }} Meter
            </span>
          </div>
        </template>
        <template #active_book_count="{ row }">
          <div class="field-wrapper">
            <span class="rounded-lg w-full">
              {{ row.active_book_count }} Content
            </span>
          </div>
        </template>
        <template #reading_progress="{ row }">
          <div class="field-wrapper">
            <span class="rounded-lg w-full">
              {{ row.reading_progress }} %
            </span>
          </div>
        </template>
        <template #actions="{ row }">
          <div class="flex justify-start items-start">
               <button type="button" @click="openModalConfirmationStatus(row)" :class="{
            'bg-blue-700': (uiStatuses[row.id] || row.status) == 1,
            'bg-gray-300': (uiStatuses[row.id] || row.status) == 9
          }"
            class="w-12 h-6 button-active-inactive flex justify-start items-start p-0 rounded-full relative transition-colors duration-200 focus:outline-none">
            <span :class="{
              'translate-x-6': (uiStatuses[row.id] || row.status) == 1,
              'translate-x-0': (uiStatuses[row.id] || row.status) == 9
            }" class="w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-200"></span>
          </button>
          </div>
       
        </template>
      </Table>
      <div v-if="totalRows / perPage > 1"
        class="flex bg-white items-center justify-between ml-0 pt-4 border-t align-middle px-3">
        <div class="font-semibold">
          <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ perPage }} <span
            class="text-gray-500 font-normal">of</span> {{ parseInt(totalRows) }}
        </div>
        <div class="mb-2">
          <t-pagination :total-items="Number(totalRows)" :per-page="perPage" v-model="currentPage" class="rounded-lg" />
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { LMap, LTileLayer, LMarker, LCircle } from 'vue2-leaflet';
import { mapState, mapActions, mapMutations } from 'vuex';
import Table from '../../components/form/table.vue';
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import Button from '@/components/ui/Button'

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

export default {
  name: 'LocationPicker',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LCircle,
    Button,
    HeaderBreadcrumbs,
    Table
  },
  data() {
    return {
     url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      zoom: 20,
      dragTimeout: null,
      center: null,
      markerPosition: null,
      searchQuery: '',
      name: '',
      query_search: '',
      currentLocation: '',
      radius: 0,
      locationTag: '',
      currentPage: 1,
      isExporting: false,
      exportCountdown: 0,
      exportInterval: null,
      perPage: 15,
      toggleDataStatus: [],
      loadingState: false,
      uiStatuses: {},
      savedLocationData: null,
      selectedRowForStatus: null,
      pendingStatusChange: null,
      permission_location: false,
      lockLocation: false,
      searchTimeout: null,
      stateEmpty:false,
      radiusErrorMessage: '',
      validateLocation: false,
      validateRadiusLocation: false,
      locationError: '',
      headers: [
        { label: 'No', key: 'no' },
        { label: 'TAG LOCATION', key: 'name' },
        { label: 'radius boundary', key: 'allowed_radius' },
        { label: 'Active Book', key: 'active_book_count' },
        { label: 'Reading Progress', key: 'reading_progress' },
        { label: 'Status', key: '',style: 'text-align: center !important;' }
      ],
      isLocationSearch: false,
      confirmLocation: false,
      debounce: null,
      showMap: false,
    };
  },
  watch: {
    locationTag(newValue) {
      if (newValue) {
        this.validateLocation = false;
      }
    },
    radius(newValue) {
      if (newValue < 50) {
        this.validateRadiusLocation = true;
        this.radiusErrorMessage = "Minimum radius is 50 meters";
      } 
      else if (newValue > 2000) {
        this.validateRadiusLocation = true;
        this.radiusErrorMessage = "Maximum radius is 2000 meters";
      } 
      else {
        this.validateRadiusLocation = false;
        this.radiusErrorMessage = "";
      }
    },
    currentPage: function () {
      this.fetchData();
    },
  },
  computed: {
    ...mapState('smartpin', {
      searchResults: state => state.items,
      listLocation: state => state.listLocation,
      totalRows: (state) => state.totalRowsLocation,
      isloadingLocation: (state) => state.isLoadingListLocation,
      isError: state => state.error,
      errorMessage: state => state.errorMessage
    }),
  },
  mounted() {
    this.checkLocationPermission();
    this.fetchData();
  },
  methods: {
    ...mapActions('smartpin', [
      'fetchMapLocations',
      'reverseGeocode',
      'postLocation',
      'getLocation',
      'updateLocationStatus'
    ]),
    ...mapMutations('smartpin', ['updateItemStatus']),

    handleOpenModalMap() {
      this.$refs.openModalMap.show();
    },
    closeMoap() {
      this.$refs.openModalMap.hide();
    },
    handleCloseMap() {
      this.currentLocation = ''
      this.searchQuery = ''
      this.showMap = false
      this.radius = null
      this.locationTag = ''
      this.confirmLocation = false
      this.radiusErrorMessage = ''
       this.$refs.openModalMap.hide();
      this.validateRadiusLocation = false
    },
    async checkLocationPermission() {
      if (navigator.permissions && navigator.permissions.query) {
        try {
          const permissionStatus = await navigator.permissions.query({ name: 'geolocation' });
          if (permissionStatus.state === 'denied') {
            this.permission_location = true
          }
          permissionStatus.onchange = () => {
            if (permissionStatus.state === 'denied') {
              this.permission_location = true
            } else if (permissionStatus.state === 'granted') {
              this.permission_location = false
            }
          };
        } catch (error) {
          console.log("Permissions API tidak disupport", error);
        }
      }
    },
    confirmationSubmitLocation() {
      this.validateLocation = false;
      this.validateRadiusLocation = false;
      let hasError = false;

      if (this.locationTag === '') {
        this.validateLocation = true;
        hasError = true;
      }

      if (this.radius === 0 || this.radius < 50 || this.radius > 2000) {
        this.validateRadiusLocation = true;
        hasError = true;
      }
       if (this.radius > 2000) {
        this.validateRadiusLocation = true;
        this.radiusErrorMessage = "Maximum radius is 2000 meters";
        this.radius = 0;
          hasError = true;
      } 
      else if (this.radius < 50) {
        this.validateRadiusLocation = true;
        this.radiusErrorMessage = "Minimum radius is 50 meters";
          hasError = true;
      } 
       else if (this.radius < 0) {
          this.validateRadiusLocation = true;
        this.radiusErrorMessage = "Minimum radius is 50 meters";
          this.radius = 0;
            hasError = true;
        }

      if (hasError) {
        this.$refs.openModalMap.show()
        return;
      }
      this.$refs.openModalConfirmationSubmitLocation.show();
    },
    onSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      this.searchTimeout = setTimeout(async () => {
        try {
          await this.getLocation({
            limit: this.perPage,
            page: this.currentPage = 1,
            query: this.query_search
          });
        } catch (error) {
          console.error("Gagal load lokasi:", error);
        }
      }, 1000);
    },
    onBeforeClose() {

    },
    async exportCSV() {
      if (this.isExporting) return;

      this.isExporting = true;
      this.exportCountdown = 5;

      this.exportInterval = setInterval(() => {
        this.exportCountdown--;

        if (this.exportCountdown <= 0) {
          clearInterval(this.exportInterval);
          this.isExporting = false;
        }
      }, 1000);

      try {
        this.loadingState = true;

        await this.getLocation({
          limit: this.totalRows || 9999,
          page: 1,
          query: this.query_search
        });

        const dataToExport = this.listLocation;
        const headers = ['No', 'Tag location ', 'Radius Boundary (Meters)', 'Active Book Count', 'Max reading progress', 'Status'];

        const rows = dataToExport.map((row, index) => {
          const statusText = (this.uiStatuses[row.id] || row.status) == 1 ? 'Active' : 'Inactive';
          return [
            index + 1,
            `"${row.name}"`,
            row.allowed_radius,
            row.active_book_count || 0,
            row.reading_progress || 0,
            statusText
          ];
        });

        const csvContent = [
          headers.join(','),
          ...rows.map(row => row.join(','))
        ].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.setAttribute('href', url);
        const date = new Date().toISOString().split('T')[0];
        link.setAttribute('download', `SmartPin_Locations_${date}.csv`);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

      } catch (error) {
        console.error("Gagal melakukan export CSV:", error);
      } finally {
        await this.fetchData();
        this.loadingState = false;
      }
    },
    openModalCSV() {
      this.$refs.openModalUploadCSV.show();
    },
   
    openModalConfirmationStatus(row) {
      this.selectedRowForStatus = row;

      let currentStatus = this.uiStatuses[row.id] || row.status;
      this.pendingStatusChange = currentStatus == 1 ? 9 : 1;

      this.$set(this.uiStatuses, row.id, this.pendingStatusChange);

      this.$refs.modalConfirmationStatus.show();
    },
    cancelStatusChange() {
      if (this.selectedRowForStatus) {
        this.$delete(this.uiStatuses, this.selectedRowForStatus.id);
      }

      this.$refs.modalConfirmationStatus.hide()
      this.selectedRowForStatus = null;
      this.pendingStatusChange = null;
    },

    onBeforeCloseModalStatus() {
      if (this.selectedRowForStatus) {
        this.$delete(this.uiStatuses, this.selectedRowForStatus.id);
      }

      this.selectedRowForStatus = null
      this.pendingStatusChange = null
    },

    confirmStatusChange() {
      let row = this.selectedRowForStatus
      let newStatus = this.pendingStatusChange

      this.selectedRowForStatus = null;
      this.pendingStatusChange = null;
      this.$refs.modalConfirmationStatus.hide();

      this.updateLocationStatus({
        id: row.id,
        status: newStatus,
        reading_progress: row.reading_progress || 25
      }).then(() => {
        this.$delete(this.uiStatuses, row.id);
        this.fetchData()
      }).catch(() => {
        this.$delete(this.uiStatuses, row.id);
        console.error("Gagal update ke backend, status UI dikembalikan.");
      });
    },

  getCurrentLocation() {
      if (!navigator.geolocation) {
        console.warn("Browser tidak mendukung Geolocation");
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          this.permission_location = false;
          this.showMap = true;
          this.updateMapPosition(lat, lng);
          this.getAddressFromCoordinates(lat, lng);
        },
        (error) => {
          switch (error.code) {
            case error.PERMISSION_DENIED:
              console.warn("User menolak akses lokasi.");
              this.permission_location = true; 
              break;
            case error.POSITION_UNAVAILABLE:
              console.warn("Informasi lokasi tidak tersedia (sinyal GPS/Wifi lemah).");
              break;
            case error.TIMEOUT:
              console.warn("Waktu habis saat mencari lokasi.");
              break;
            default:
              console.warn("Terjadi error yang tidak diketahui.");
              break;
          }
        },
        { 
          enableHighAccuracy: true, 
          timeout: 10000,
          maximumAge: 0 
        }
      );
    },
    async getAddressFromCoordinates(lat, lng) {
      try {
        const payload = {
          lat: lat,
          lon: lng
        };
        const data = await this.reverseGeocode(payload);
       if (data) {
          this.currentLocation = data.display_name || data.name ;
          this.searchQuery = data.display_name || data.name;
          this.name = data.name || 'Pinned Location'; 
        }
      } catch (error) {
        console.error("Komponen: Gagal mendapatkan alamat dari koordinat", error);
      }
    },
    async fetchData() {
      if (!this.query_search) {
        try {
          await this.getLocation({
            limit: this.perPage,
            page: this.currentPage
          });
        } catch (error) {
          console.error("Gagal load lokasi:", error);
        }
      }

    },
    searchLocationsMap() {
      if (!this.searchQuery || this.searchQuery.length < 3){
         return;
      }
      this.isLocationSearch = true;
      clearTimeout(this.debounce);

      this.debounce = setTimeout(() => {

        const coordinateRegex = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)\s*,\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/;
        const textInput = this.searchQuery.trim();

        if (coordinateRegex.test(textInput)) {
          const [lat, lng] = textInput.replace(/\s/g, '').split(',');
          this.updateMapPosition(Number(lat), Number(lng));
          this.getAddressFromCoordinates(Number(lat), Number(lng));
          this.isLocationSearch = false;
          this.showMap = true;
        } else {
          let payload = {
            q: this.searchQuery,
            limit: 50,
            countrycodes: 'id',
          };

          this.fetchMapLocations(payload)
            .then((respons) => {
              this.isLocationSearch = false;
              if(respons.length === 0) {
                 this.stateEmpty = true
              }
             
            })
            .catch(() => {
              this.isLocationSearch = false;
                this.stateEmpty = true
            });
        }
      }, 1500);
    },
    onLocationSelected(result) {
      if (!result) return;
      this.showMap = true;

      const lat = parseFloat(result.lat);
      const lng = parseFloat(result.lon);

      this.updateMapPosition(lat, lng);
      this.searchQuery = result.display_name;
      this.name = result?.name
      this.fetchMapLocations({ q: '', limit: 0 });
    },

    onMarkerDragEnd(event) {
      const newLatLng = event.target.getLatLng();
      this.markerPosition = { lat: newLatLng.lat, lng: newLatLng.lng };
      this.center = [newLatLng.lat, newLatLng.lng];
      this.getAddressFromCoordinates(newLatLng.lat, newLatLng.lng);
    },
    handleBackSetLocation() {
      this.confirmLocation = false
      this.radius = 0
      this.lockLocation = false
    },
    updateMapPosition(lat, lng) {
      this.markerPosition = { lat, lng };
      this.center = [lat, lng];
      this.zoom = 16;

      this.$nextTick(() => {
        if (this.$refs.myMap && this.$refs.myMap.mapObject) {
          this.$refs.myMap.mapObject.flyTo([lat, lng], 16, { animate: false, duration: 1.5 });
        }
      });
    },

   validateRadius() {
      if (this.radius === 0) {
        this.validateRadiusLocation = true;
        this.radiusErrorMessage = "Minimum radius is 50 meters";
        return;
      }

      let val = Number(this.radius);

      if (val > 2000) {
        this.validateRadiusLocation = true;
        this.radiusErrorMessage = "Maximum radius is 2000 meters";
        this.radius = 0;
      } 
      else if (val < 50) {
        this.validateRadiusLocation = true;
        this.radiusErrorMessage = "Minimum radius is 50 meters";
      } 
       else if (val < 0) {
          this.validateRadiusLocation = true;
        this.radiusErrorMessage = "Minimum radius is 50 meters";
          this.radius = 0;
        }
      else {
        this.validateRadiusLocation = false;
        this.radiusErrorMessage = "";
        this.radius = val;
      }
    },
    confirmLocationData() {
      String(this.markerPosition.lat)
      String(this.markerPosition.lng)
      this.confirmLocation = true
      this.lockLocation = true
    },
    async submitLocation() {
      this.loadingState = true;
      this.$refs.openModalMap.hide();
      this.$refs.openModalConfirmationSubmitLocation.hide();
      const payload = {
        latitude: String(this.markerPosition.lat),
        longitude: String(this.markerPosition.lng),
        allowed_radius: this.radius,
        name: this.locationTag
      };

      try {
        const result = await this.postLocation(payload);
        setTimeout(() => {
          this.loadingState = false;
          this.savedLocationData = result.data || result;
          this.$refs.openDatalocation.show();
        }, 3000);
      } catch (error) {
        console.error('Gagal menyimpan:', error);
      }
    },
    downloadQR() {
      if (!this.savedLocationData || !this.savedLocationData.qr_image) {
        console.error('Data QR tidak ditemukan');
        return;
      }

      const downloadLink = document.createElement('a');

      downloadLink.href = this.savedLocationData.qr_image;

      const fileName = this.savedLocationData.name.replace(/\s+/g, '_')
      downloadLink.download = `QR_${fileName}.png`;

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      this.$refs.openDatalocation.hide();
    },

  }
};
</script>

<style scoped>
.custom-dropdown-list {
  position: absolute;
  top: 130px;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  border-top: none;
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 250px;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.button-active-inactive {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.custom-dropdown-list li {
  padding: 10px;
  cursor: pointer;
  font-size: 13px;
}

.custom-dropdown-list li:hover {
  background: #f8f9fa;
}

.animate-spin {
  animation: custom-spin 1s linear infinite;
}

@keyframes custom-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
